import * as React from "react";
import Header from "./Header";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface UnavailableHtmlProps {
  html: string;
  isPopout: boolean;
  onClose: () => void;
  onCollapse: () => void;
  onPopout: () => void;
}

class UnavailableHtml extends React.Component<UnavailableHtmlProps, {}> {
  render() {
    return (
      <MessengerFlexContainer>
        <Header
          isPopout={this.props.isPopout}
          onCollapse={this.props.onCollapse}
        />
        <div
          className="velaro-unavailable-html-content"
          dangerouslySetInnerHTML={{ __html: this.props.html }}
        />
      </MessengerFlexContainer>
    );
  }
}

export default UnavailableHtml;
